import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import SVGIcon from "../common/svg-icon";

function SaveForLater({ onClick, isSaved }) {
    return (
        <div className="product-card__save-for-later-signup-prompt product-card__save-for-later">
            <button
                onClick={onClick}
                className={classnames("save-for-later-button", "save-for-later-button--icon", {
                    "save-for-later-button--icon-saved": isSaved
                })}
            >
                <SVGIcon name="heart" />
            </button>
        </div>
    );
}

export default SaveForLater;

SaveForLater.propTypes = {
    onClick: PropTypes.func.isRequired,
    isSaved: PropTypes.bool.isRequired
};
